import { Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ServiceDetails from './ServiceDetails';

export default function OrdersDetails({ order }) {
  const { t } = useTranslation('orders');
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        p: 2,
        background: '#FAFAFA',
      }}
    >
      <Stack gap={1.75} width="100%">
        <Typography variant="subtitle2" color="textPrimary">
          {t(`newOrder.services.category.${order.services[0].type}`)}
        </Typography>
        <Stack gap={1}>
          {order.services
            .filter(service => !service.declinedAt && !service.approvedAt)
            .map(service => (
              <ServiceDetails
                key={service.vendorOrderServiceId}
                service={service}
                orderType={order.orderType}
              />
            ))}
        </Stack>
      </Stack>
    </Paper>
  );
}
